import React from 'react';
import { motion } from 'framer-motion';
import { useParams } from 'react-router-dom';
import { MapPin, Clock, Car, Bed, FileText, Download, Music } from 'lucide-react';
export function SharedItineraryPage() {
  const {
    shareId
  } = useParams();
  return <div className="min-h-screen bg-background text-textMain" data-id="element-7003">
      {/* Header */}
      <header className="h-16 border-b border-border flex items-center justify-between px-6 bg-surface/50 backdrop-blur sticky top-0 z-50" data-id="element-7004">
        <div className="flex items-center gap-3" data-id="element-7005">
          <div className="w-8 h-8 rounded-lg bg-primary/20 flex items-center justify-center text-primary font-bold text-xs" data-id="element-7006">
            TW
          </div>
          <span className="font-semibold" data-id="element-7007">The Wildwoods • Summer Run '26</span>
        </div>
        <button className="px-4 py-2 bg-surface border border-border rounded-lg text-sm font-medium hover:bg-surfaceHover transition-colors flex items-center gap-2" data-id="element-7008">
          <Download className="w-4 h-4" data-id="element-7009" /> Download PDF
        </button>
      </header>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="max-w-3xl mx-auto px-6 py-12" data-id="element-7010">
        <div className="mb-8" data-id="element-7011">
          <h1 className="text-3xl font-bold mb-2" data-id="element-7012">Tour Itinerary</h1>
          <p className="text-textMuted" data-id="element-7013">
            Read-only view • Last updated 2 hours ago
          </p>
        </div>

        <div className="space-y-12" data-id="element-7014">
          {/* Day 1 */}
          <div data-id="element-7015">
            <div className="sticky top-16 bg-background/95 backdrop-blur py-4 z-10 mb-6 border-b border-border" data-id="element-7016">
              <h2 className="text-xl font-bold" data-id="element-7017">Friday, June 12</h2>
              <p className="text-sm text-textMuted" data-id="element-7018">Chicago, IL</p>
            </div>

            <div className="relative pl-8 space-y-6" data-id="element-7019">
              <div className="absolute left-[15px] top-2 bottom-0 w-px bg-border" data-id="element-7020"></div>

              {/* Travel */}
              <div className="relative" data-id="element-7021">
                <div className="absolute -left-8 w-6 h-6 rounded-full bg-surface border-2 border-border flex items-center justify-center z-10" data-id="element-7022">
                  <Car className="w-3 h-3 text-textMuted" data-id="element-7023" />
                </div>
                <div className="bg-surface border border-border rounded-xl p-5" data-id="element-7024">
                  <div className="flex justify-between items-start mb-2" data-id="element-7025">
                    <h4 className="font-semibold" data-id="element-7026">Drive to Chicago</h4>
                    <span className="text-sm text-textMuted" data-id="element-7027">
                      10:00 AM - 2:00 PM
                    </span>
                  </div>
                  <div className="text-sm text-textMuted flex items-center gap-4" data-id="element-7028">
                    <span className="flex items-center gap-1" data-id="element-7029">
                      <MapPin className="w-4 h-4" data-id="element-7030" /> 240 miles
                    </span>
                    <span className="flex items-center gap-1" data-id="element-7031">
                      <Clock className="w-4 h-4" data-id="element-7032" /> ~4 hours
                    </span>
                  </div>
                </div>
              </div>

              {/* Lodging */}
              <div className="relative" data-id="element-7033">
                <div className="absolute -left-8 w-6 h-6 rounded-full bg-surface border-2 border-border flex items-center justify-center z-10" data-id="element-7034">
                  <Bed className="w-3 h-3 text-textMuted" data-id="element-7035" />
                </div>
                <div className="bg-surface border border-border rounded-xl p-5" data-id="element-7036">
                  <div className="flex justify-between items-start mb-2" data-id="element-7037">
                    <h4 className="font-semibold" data-id="element-7038">Check-in: The Robey</h4>
                    <span className="text-sm text-textMuted" data-id="element-7039">3:00 PM</span>
                  </div>
                  <p className="text-sm text-textMuted mb-3" data-id="element-7040">
                    2018 W North Ave, Chicago, IL 60647
                  </p>
                  <div className="inline-flex items-center gap-1 px-2 py-1 bg-background rounded text-xs font-medium border border-border" data-id="element-7041">
                    <FileText className="w-3 h-3" data-id="element-7042" /> Conf: #H-882910
                  </div>
                </div>
              </div>

              {/* Show */}
              <div className="relative" data-id="element-7043">
                <div className="absolute -left-8 w-6 h-6 rounded-full bg-primary/20 border-2 border-primary flex items-center justify-center z-10" data-id="element-7044">
                  <Music className="w-3 h-3 text-primary" data-id="element-7045" />
                </div>
                <div className="bg-surface border border-primary/30 rounded-xl p-6 shadow-[0_0_15px_rgba(245,158,11,0.05)]" data-id="element-7046">
                  <div className="mb-6" data-id="element-7047">
                    <h4 className="font-bold text-xl text-primary mb-1" data-id="element-7048">
                      The Empty Bottle
                    </h4>
                    <p className="text-sm text-textMuted" data-id="element-7049">
                      1035 N Western Ave, Chicago, IL
                    </p>
                  </div>
                  <div className="grid grid-cols-2 sm:grid-cols-4 gap-6" data-id="element-7050">
                    <div data-id="element-7051">
                      <div className="text-xs text-textMuted mb-1" data-id="element-7052">Load-in</div>
                      <div className="text-base font-medium" data-id="element-7053">5:00 PM</div>
                    </div>
                    <div data-id="element-7054">
                      <div className="text-xs text-textMuted mb-1" data-id="element-7055">
                        Soundcheck
                      </div>
                      <div className="text-base font-medium" data-id="element-7056">6:00 PM</div>
                    </div>
                    <div data-id="element-7057">
                      <div className="text-xs text-textMuted mb-1" data-id="element-7058">Doors</div>
                      <div className="text-base font-medium" data-id="element-7059">8:00 PM</div>
                    </div>
                    <div data-id="element-7060">
                      <div className="text-xs text-textMuted mb-1" data-id="element-7061">
                        Set Time
                      </div>
                      <div className="text-base font-bold text-primary" data-id="element-7062">
                        10:00 PM
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </div>;
}